import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent {

    @Input() id: string;
    @Input() label: string;
    @Input() value: string;

    @Output() valueChanged: EventEmitter<string> = new EventEmitter();

    constructor() { }

    getValue(): boolean {
        return parseInt(this.value, 10) === 1 ? true : false;
    }

    onValueChanged(value: boolean) {
        this.valueChanged.emit(value ? '1' : '0');
    }
}
